import type { ComponentType } from 'react';
import React from 'react';
import type { IconProps } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './AccountPopover.styles';

interface AccountItemProps {
  Icon?: ComponentType<IconProps>;
  iconProps?: IconProps;
  text: string;
}

export const AccountItem = ({ Icon, iconProps, text }: AccountItemProps) => (
  <span css={[styles.accountItem]}>
    {Icon && iconProps && (
      <span css={styles.accountItemIconContainer}>
        <Icon {...iconProps} />
      </span>
    )}
    {text}
  </span>
);
